import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsCounterSource, PmsCounterSource } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsCounterSource>
    useData={usePmsCounterSource}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
